import React from 'react';
import { ReviewModel } from '../typings/reviews';

export const ReviewsContext = React.createContext<
  [
    ReviewModel | undefined,
    React.Dispatch<React.SetStateAction<ReviewModel | undefined>> | undefined,
  ]
>([undefined, undefined]);

export function ReviewsDataService(props: any) {
  const stateHook = React.useState<ReviewModel | undefined>(props.reviews);
  return (
    <ReviewsContext.Provider value={stateHook}>
      {props.children}
    </ReviewsContext.Provider>
  );
}

export function useReviewModel(): ReviewModel | undefined {
  const [reviewModel] = React.useContext(ReviewsContext);
  return reviewModel;
}

export function useUpdateReviewModel() {
  const updateModel = React.useContext(ReviewsContext)[1];
  return updateModel;
}
